import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { Button, Select, DatePicker, message } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import { FilterOutlined } from "@ant-design/icons";
import { useIrnStore } from "../../../store/useIrnstore";
import dayjs from "dayjs";
import { useVendorMasterStore } from "../../../store/useVendorMasterStore";

export const VendorReportForm = ({ setLastPayload }) => {
  const { getPeriods, periods } = useIrnStore();
  const { getVendorReports } = useVendorMasterStore();
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const hasRunRef = useRef(false);

  useEffect(() => {
    getPeriods();
  }, []);

  useEffect(() => {
    if (periods?.length) {
      handlePeriodChange(periods?.[0]?.PeriodId);
    }
  }, [periods]);

  useEffect(() => {
    if (selectedPeriod && fromDate && toDate && !hasRunRef.current) {
      handleFilter();
      hasRunRef.current = true;
    }
  }, [toDate]);

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);
    const selected = periods.find((p) => p.PeriodId === value);

    if (selected) {
      if (selected.PeriodName === "Custom") {
        // For custom, clear dates and let user select
        setFromDate(null);
        setToDate(null);
      } else {
        // Set dates from the selected period
        setFromDate(dayjs(selected.FromDate));
        setToDate(dayjs(selected.Todate));
      }
    }
  };

  const handleFilter = async () => {
    // Validation
    if (!selectedPeriod) {
      message.error("Please select a period");
      return;
    }

    if (!fromDate || !toDate) {
      message.error("Please select both From Date and To Date");
      return;
    }

    try {
      const fromDateStr = fromDate.format("YYYY-MM-DD");
      const toDateStr = toDate.format("YYYY-MM-DD");
      const payload = {
        fromDate: fromDateStr,
        toDate: toDateStr,
      };
      setLastPayload(payload);
      await getVendorReports(fromDateStr, toDateStr);
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      alert("An error occurred while fetching data");
    }
  };

  const isCustomPeriod = () => {
    const selected = periods.find((p) => p.PeriodId === selectedPeriod);
    return selected && selected.PeriodName === "Custom";
  };

  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Period"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            value={selectedPeriod}
            onChange={handlePeriodChange}
            options={periods.map((period) => ({
              value: period.PeriodId,
              label: period.PeriodName,
            }))}
          />
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel children={"From Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={fromDate}
            onChange={(date) => setFromDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>

        <Col xl={3} md={6}>
          <CustomLabel children={"To Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={toDate}
            onChange={(date) => setToDate(date)}
            disabled={!isCustomPeriod() && selectedPeriod !== null}
          />
        </Col>
        <Col xl={3} md={6} style={{ textAlign: "center", marginTop: 20 }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              backgroundColor: "#1aa8c4ff", // elegant green
              borderColor: "#1a94c4ff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={handleFilter}
          >
            Search
          </Button>
        </Col>
      </Row>
    </>
  );
};
